<div class="row ptb50">
    <div class="col">
        <div translate class="filtro ng-star-inserted sm-font" style="margin: 0px 10px 0px 0px;">
            {{'businessIntelligence.registro1Servico.dataReferencia'}}
        </div>
        <div class="input-group input-group-sm data-fixo marge">
            <select class="form-control form-control-sm" type="text" placeholder="Selecione o ano..."
                [(ngModel)]="filtros.ano" [(ngModel)]="ano" (ngModelChange)="onKey($event)">
                <option *ngFor="let ano of anoDropDown" value={{ano.value}}>{{ano.value}}</option>
            </select>
        </div>
    </div>
</div>